import { Aspect as i } from "./index5.js";
import { CROP_MINIMUM_DIMENSION_PERCENTAGE as n } from "./index37.js";
import { getPixelValueFromPercent as m } from "./index38.js";
const r = {
  [i.CUSTOM]: 0,
  [i.CIRCLE]: 1,
  [i.SQUARE]: 1,
  [i.PORTRAIT]: 3 / 4,
  [i.LANDSCAPE]: 4 / 3,
  [i.WIDE]: 16 / 9,
  [i.COVER]: 16 / 10
}, c = (t) => r[t], p = (t, o, s) => {
  if (s === 0)
    return { width: t, height: o };
  if (t / o > s)
    return { width: o * s, height: o };
  const h = t / s;
  return { width: t, height: h };
}, I = (t, o) => {
  const s = m(
    n,
    t.width
  ), e = m(
    n,
    t.height
  );
  return p(
    s,
    e,
    c(o)
  );
};
export {
  p as adjustDimensionsForAspectRatio,
  r as aspectRatioMap,
  I as getMinimumCropAspect,
  c as getRatioBasedOnAspect
};
